import Tooltip from '@mui/material/Tooltip';
import type { TooltipProps } from '@mui/material/Tooltip';

export type CalmTooltipProps = TooltipProps;

/**
 * A wrapper around MUI Tooltip with calmer defaults
 * (slower enter, instant leave, non-interactive).
 * Consumers can still override any prop.
 */
export function CalmTooltip({
  enterDelay = 800,
  enterNextDelay = 800,
  leaveDelay = 0,
  disableInteractive = true,
  disableFocusListener = true,
  disableTouchListener = true,
  TransitionProps = { timeout: 0 },
  PopperProps = {
    popperOptions: { strategy: 'fixed' },
    modifiers: [
      { name: 'preventOverflow', options: { boundary: 'viewport', altAxis: true } },
    ],
  },
  ...rest
}: CalmTooltipProps) {
  return (
    <Tooltip
      enterDelay={enterDelay}
      enterNextDelay={enterNextDelay}
      leaveDelay={leaveDelay}
      disableInteractive={disableInteractive}
      disableFocusListener={disableFocusListener}
      disableTouchListener={disableTouchListener}
      TransitionProps={TransitionProps}
      PopperProps={PopperProps}
      {...rest}
    />
  );
}
